<template>
	<div
			v-show="featureToggles.showAvailableVouchersInBasket && activeUserVouchers.length && !($store.getters.vouchersRedeemed || []).length"
			class="voucher-carousel-wrapper"
	>
		<carousel
				ref="carousel"
				:autoplay="false"
				:per-page="calculatePerPage"
				:mouseDrag="true"
				:scrollPerPage="false"
				:centerMode="true"
				:paginationEnabled="false"
				:navigationEnabled="false"
				:navigationPrevLabel="''"
				:navigationNextLabel="''"
		>
			<slide v-for="voucher in activeUserVouchers" :key="voucher.id">
				<VoucherCarouselItem
					:key="voucher.id"
					:voucher="voucher"
					:isVoucherCarouselContext="isVoucherCarouselContext"
					:userVouchers="activeUserVouchers"
					:voucherProducts="voucherProducts"
				/>
			</slide>
		</carousel>
	</div>
</template>

<script>
import {mapGetters} from "vuex";
import {Carousel, Slide} from "vue-carousel/src";
import VoucherCarouselItem from "./VoucherCardItem.vue";
import ProductProvider from "../../../../providers/ProductProvider";
import {filterCurrentUserFavoriteProductListByShopId} from "../../../../libraries/utils";
import routeMapper from "../../../../router/routeMapper";
import {pushGTMInternal} from "../../../../integrations/tracking/gtm/pushGtmEvents";
import {
	verifyVoucherAvailability
} from "../../../../helper/VoucherValidationHelper";
import {cloneDeep} from "lodash";
import {isProductCatalogDataAvailable} from "../../../../store/ProductCatalogNonReactiveStorage";

export default {
	name: "VoucherCarousel",
	data() {
		return {
			isVoucherCarouselContext: true,
			voucherProducts: []
		};
	},
	components: {
		VoucherCarouselItem,
		Carousel,
		Slide
	},
	mixins: [],
	computed: {
		...mapGetters([
			"userCrmVouchersAndMilestoneRewards",
			"productCatalog",
			"featureToggles",
			"limitedDiscountAssignments"
		]),
		activeUserVouchers() {
			const vouchers = this.userCrmVouchersAndMilestoneRewards.filter(verifyVoucherAvailability);
			const redeemedVouchers = this.$store.getters.vouchersRedeemed || [];
			if(this.$store.getters.globalSelectedShop && isProductCatalogDataAvailable()) {
				const clonedVouchers = cloneDeep(vouchers);
				return clonedVouchers.filter(voucher => {
					const mappedProducts = voucher.productPattern.map(productId => ({productId}));
					const validProducts = filterCurrentUserFavoriteProductListByShopId(
						mappedProducts,
						this.productCatalog,
						this.$store.getters.globalSelectedShop.id,
						this.$store.getters.cachedPickupRules
					);
					voucher.productPattern = validProducts.map(p => p.productId);
					return Boolean((validProducts && validProducts.length) || !mappedProducts.length) && !redeemedVouchers.includes(voucher.id);
				});
			}
			return vouchers;
		},
		calculatePerPage() {
			if(this.$route.name === routeMapper.routeNames.fullBasket) {
				if(this.activeUserVouchers.length <= 2) {
					return 2;
				} else {
					return 2.2;
				}
			} else {
				if(this.activeUserVouchers.length === 1) {
					return 1;
				} else {
					return 1.2;
				}
			}
		}
	},
	async created() {
		if(!isProductCatalogDataAvailable()) {
			const productIds = this.activeUserVouchers.map(voucher => voucher.productPattern).flat();
			this.voucherProducts = await ProductProvider.getProducts({productIds});
		}
		if(this.activeUserVouchers.length && this.featureToggles.showAvailableVouchersInBasket) {
			pushGTMInternal(
				"voucher_impression",
				this.$route.name,
				this.$route.path,
				"carousel_vouchers"
			);
		}
	},
	watch: {
		limitedDiscountAssignments() {
			const self = this;
			self.activeUserVouchers;
		}
	}
};
</script>

<style scoped lang="scss">
div.voucher-carousel-wrapper {
	background-color: transparent;
	/deep/ .VueCarousel-slide:not(:first-child) {
		.voucher-card {
			margin-left: 16px;
		}
	}
	&.flex.component-class {
		background-color: transparent;
	}
}
</style>
